import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'searchmiscellaneousreimbursement',
  props: ['despesasidEnviarCoordenador', 'UnicaDespesa', 'temCoordenador'],
  mixins: [ActionsForm, ExpenseMixin],
  components: {AutocompleteZ},
  data () {
    return {
      form: {
        coordenadorId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    voltar () {
      this.$refs.responsavelTypeahead.clear()
      let fechar = true
      this.$emit('fecharEnviarCoordenador', fechar)
    },
    enviar () {
      if (this.UnicaDespesa === true) {
        this.enviarUnicaDespesa()
        return true
      } else {
        if ((this.hasRole(this.roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL))) {
          if ((this.form.coordenadorId.value !== null && this.form.coordenadorId.value !== undefined)) {
            MiscellaneousExpensesRepository.ToApproveContraladoria({Fluxo: 0, despesaDiversosids: this.despesasidEnviarCoordenador, CoordenadorId: this.form.coordenadorId.value})
              .then((Response) => {
                loading.pop()
                let enviado = true
                this.$emit('onloadReacarregar', enviado)
                toast.success('Despesa Aprovada com Sucesso!!')
              })
              .catch((Error) => {
                loading.pop()
                toast.error('Erro ao Aprovar a Despesa')
              })
          } else {
            toast.error('Escolha um Coordenador')
          }
        }
      }
    },
    enviarUnicaDespesa () {
      if ((this.hasRole(this.roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL))) {
        if ((this.form.coordenadorId.value !== null && this.form.coordenadorId.value !== undefined)) {
          loading.push()
          MiscellaneousExpensesRepository.NextStatus(this.despesasidEnviarCoordenador, this.form.coordenadorId.value)
            .then((Response) => {
              let enviado = true
              this.$emit('onloadReacarregar', enviado)
              this.$emit('fechaModalAprovacaoEnvioCoordenador', enviado)
              toast.success('Despesa Aprovada com Sucesso!!')
              loading.pop()
            })
            .catch((Error) => {
              loading.pop()
            })
        } else {
          toast.error('Escolha um Coordenador')
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/addCoordinator/addCoordinator.js